module.exports = __webpack_public_path__ + "img/thumbnail_TamworthPig_m_normal.c8381dfa.png";